// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Toolbar_tooltip__uwRSx","tooltip-content":"Toolbar_tooltip-content__IUG6S","space":"Toolbar_space__N8jvG","divider":"Toolbar_divider__NILF3"};